var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import noop from '../../util/noop';
import { ButtonElement, IconWrapper } from './elements';
import { Icon } from '../Icon';
var btnSizeToIconSize = {
    small: 'normal',
    medium: 'large',
    large: 'xlarge'
};
export var Button = React.forwardRef(function (_a, fRef) {
    var id = _a.id, className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.onClick, onClick = _c === void 0 ? noop : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? '' : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, children = _a.children, iconSrc = _a.iconSrc, _g = _a.iconSide, iconSide = _g === void 0 ? 'left' : _g, rest = __rest(_a, ["id", "className", "variant", "onClick", "disabled", "ariaLabel", "size", "children", "iconSrc", "iconSide"]);
    var renderIcon = function () { return (React.createElement(IconWrapper, { "$iconSide": iconSide, "$size": size, "$childrenPresent": !!children },
        React.createElement(Icon, { src: iconSrc, size: btnSizeToIconSize[size], fill: "currentColor" }))); };
    return (React.createElement(InternalProvider, null,
        React.createElement(ButtonElement, __assign({ ref: fRef, id: id, "aria-label": ariaLabel, className: className, onClick: onClick, disabled: disabled, "$btnSize": size, "$btnVariant": variant, "$childrenPresent": !!children, "$iconSide": iconSide, "$iconPresent": !!iconSrc }, rest),
            iconSrc && iconSide === 'left' && renderIcon(),
            children,
            iconSrc && iconSide === 'right' && renderIcon())));
});
